export class GalleryApiError extends Error {}
